import { FC, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useLogUserUrl } from '@/entities/user-url-log';
import { buildMaskedUrl } from '../model/maskSensitiveUrl';

/**
 * Наблюдатель навигации: на каждый переход (включая SPA-переходы без перезагрузки)
 * маскирует чувствительные query-параметры и fire-and-forget отправляет запись в лог URL.
 * Рендерит null — монтируется внутри авторизованного лейаута.
 */
export const UserUrlLogTracker: FC = () => {
  const location = useLocation();
  const { mutate } = useLogUserUrl();
  const lastUrlRef = useRef<string | null>(null);

  useEffect(() => {
    const url = buildMaskedUrl(location.pathname, location.search);

    // Не повторяем отправку одного и того же URL подряд (в т.ч. при ремоунте в StrictMode).
    if (lastUrlRef.current === url) return;
    lastUrlRef.current = url;

    mutate({ url });
  }, [location.pathname, location.search, mutate]);

  return null;
};
